/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M18 95.75h64c6.629 0 12-5.371 12-12v-58c0-6.629-5.371-12-12-12h-8v-5.5c0-2.21-1.79-4-4-4s-4 1.79-4 4v5.5H34v-5.5c0-2.21-1.79-4-4-4s-4 1.79-4 4v5.5h-8c-6.629 0-12 5.371-12 12v58c0 6.629 5.371 12 12 12zm64-8H18c-2.21 0-4-1.79-4-4v-33h72v33a3.997 3.997 0 01-4 4zm-64-66h8v4.5c0 2.21 1.79 4 4 4s4-1.79 4-4v-4.5h32v4.5c0 2.21 1.79 4 4 4s4-1.79 4-4v-4.5h8a3.997 3.997 0 014 4v17H14v-17c0-2.21 1.79-4 4-4z"/>'
  }
})
